// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.json-table {
  border: 2px solid #433e3e;
  border-collapse: collapse;
  width: 100%; /* Ensure the table takes full width */
}

.json-table th,
.json-table td {
  border: 1px solid #3c3838;
  padding: 8px;
}

.scrollable-containers {
  overflow: auto;
  width: 100%; /* Adjust this width as necessary */
}

.scrollable-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.scrollable-table th,
.scrollable-table td {
  padding: 8px;
  border: 1px solid #ddd;
  white-space: nowrap; /* Prevent wrapping */
}

.table th {
  background-color: #E67016;
  color: white;
}

.full-height-containers {
  height: 100vh; /* Full viewport height */
  overflow: auto; /* Enable vertical scrollbar if necessary */
  padding: 20px; /* Add padding if needed */
}

/* Remove underline from links in the table */
.table .link-info {
    text-decoration: none;
    color: #26b7ec;
}


.link-info:hover {
  color: #26b7ec; /* Custom color for hover state */
  text-decoration: none; /* Optional: Add underline on hover if desired */
}`, "",{"version":3,"sources":["webpack://./src/assets/css/Jsontable.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW,EAAE,sCAAsC;AACrD;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,yBAAyB;EACxC,cAAc,EAAE,2CAA2C;EAC3D,aAAa,EAAE,0BAA0B;AAC3C;;AAEA,6CAA6C;AAC7C;IACI,qBAAqB;IACrB,cAAc;AAClB;;;AAGA;EACE,cAAc,EAAE,iCAAiC;EACjD,qBAAqB,EAAE,gDAAgD;AACzE","sourcesContent":[".json-table {\r\n  border: 2px solid #433e3e;\r\n  border-collapse: collapse;\r\n  width: 100%; /* Ensure the table takes full width */\r\n}\r\n\r\n.json-table th,\r\n.json-table td {\r\n  border: 1px solid #3c3838;\r\n  padding: 8px;\r\n}\r\n\r\n.scrollable-containers {\r\n  overflow: auto;\r\n  width: 100%; /* Adjust this width as necessary */\r\n}\r\n\r\n.scrollable-table {\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.scrollable-table th,\r\n.scrollable-table td {\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  white-space: nowrap; /* Prevent wrapping */\r\n}\r\n\r\n.table th {\r\n  background-color: #E67016;\r\n  color: white;\r\n}\r\n\r\n.full-height-containers {\r\n  height: 100vh; /* Full viewport height */\r\n  overflow: auto; /* Enable vertical scrollbar if necessary */\r\n  padding: 20px; /* Add padding if needed */\r\n}\r\n\r\n/* Remove underline from links in the table */\r\n.table .link-info {\r\n    text-decoration: none;\r\n    color: #26b7ec;\r\n}\r\n\r\n\r\n.link-info:hover {\r\n  color: #26b7ec; /* Custom color for hover state */\r\n  text-decoration: none; /* Optional: Add underline on hover if desired */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
